var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageMasterSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/page-master-silver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3.515625e-05 0 45 0 45 47.9999652 3.515625e-05 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-743.000000, -585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/page-master-silver",
    transform: "translate(743.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,47.9999652 L22.5000352,47.9999652 C10.073707,47.9999652 3.515625e-05,38.0333565 3.515625e-05,25.7390957 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,25.7390957 C45.0000352,38.0333565 34.9263633,47.9999652 22.5000352,47.9999652",
    id: "Fill-1",
    fill: "#8E9FA8",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,44.5217043 L22.5000352,44.5217043 C10.073707,44.5217043 3.515625e-05,34.5550957 3.515625e-05,22.2608348 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,22.2608348 C45.0000352,34.5550957 34.9263633,44.5217043 22.5000352,44.5217043",
    id: "Fill-4",
    fill: "#D6E4EF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7812852,-3.47826087e-05 L4.21878516,-3.47826087e-05 C1.88898047,-3.47826087e-05 3.515625e-05,1.86883478 3.515625e-05,4.17387826 L3.515625e-05,22.2608348 C3.515625e-05,34.5550957 10.0733555,44.5217043 22.5000352,44.5217043 L22.5000352,44.5217043 C34.9263633,44.5217043 45.0000352,34.5550957 45.0000352,22.2608348 L45.0000352,4.17387826 C45.0000352,1.86883478 43.1110898,-3.47826087e-05 40.7812852,-3.47826087e-05 M40.7812852,4.17387826 L40.7812852,22.2608348 C40.7812852,32.2340522 32.5803867,40.3477913 22.5000352,40.3477913 C12.4196836,40.3477913 4.21878516,32.2340522 4.21878516,22.2608348 L4.21878516,4.17387826 L40.7812852,4.17387826",
    id: "Fill-7",
    fill: "#B6C4CE",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0108789,12.452487 L33.444668,12.452487 L11.3377148,12.452487 L9.98912109,12.452487 C9.25013672,12.452487 8.65072266,13.0455304 8.65072266,13.7766609 L8.65072266,28.4904 C8.65072266,29.2215304 9.25013672,29.8145739 9.98912109,29.8145739 L19.5695508,29.8145739 C19.5695508,30.7891826 20.3683008,31.5794435 21.3533789,31.5794435 L23.6466211,31.5794435 C24.6316992,31.5794435 25.4304492,30.7891826 25.4304492,29.8145739 L35.0108789,29.8145739 C35.7502148,29.8145739 36.3492773,29.2215304 36.3492773,28.4904 L36.3492773,13.7766609 C36.3492773,13.0455304 35.7502148,12.452487 35.0108789,12.452487",
    id: "Fill-10",
    fill: "#8E9FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2319727,27.409287 L25.4304492,27.409287 C24.065332,27.409287 22.9174805,28.2778087 22.5922852,29.4538087 L22.4077148,29.4538087 C22.0825195,28.2778087 20.9353711,27.409287 19.5695508,27.409287 L11.7673242,27.409287 C11.3658398,27.409287 11.0392383,27.0868522 11.0392383,26.6889391 L11.0392383,10.2312 C11.0392383,9.83398261 11.3658398,9.51085217 11.7673242,9.51085217 L19.5695508,9.51085217 C21.187793,9.51085217 22.5001758,10.7313739 22.5001758,12.2367652 C22.5001758,10.7313739 23.8118555,9.51085217 25.4304492,9.51085217 L33.2319727,9.51085217 C33.6341602,9.51085217 33.9600586,9.83328696 33.9600586,10.2312 L33.9600586,26.6889391 C33.9600586,27.0868522 33.6341602,27.409287 33.2319727,27.409287",
    id: "Fill-12",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5000352,
    y1: 12.0253565,
    x2: 22.5000352,
    y2: 28.7154435,
    id: "Stroke-14",
    stroke: "#E2E9F2",
    strokeWidth: 1.73913043,
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageMasterSilver);
export default __webpack_public_path__ + "static/media/page-master-silver.b8c75f97c4ddbacd18d3d072ffa19338.svg";
export { ForwardRef as ReactComponent };